"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var _styles = require("./styles");

var _Tooltip = require("../Tooltip");

var _jsxRuntime = require("react/jsx-runtime");

var ProgressBar = function ProgressBar(_ref) {
  var percent = _ref.percent,
      progressBarType = _ref.progressBarType,
      percentRequired = _ref.percentRequired;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [percentRequired ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
        componentTooltip: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: "Campos requeridos"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: ["Este nuevo icono te indicar\xE1 cuando ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), " completes todos los campos requeridos"]
          })]
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerIcon, {
          className: "fondo",
          percentageRequired: percentRequired,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            class: "hola",
            children: "local_police"
          })
        }),
        classNameTooltip: "container-tooltip"
      })
    }) : "", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
      componentTooltip: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: "Porcentaje de requeridos"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Este porcentaje indica la completitud de los atributos requeridos para todos los servicios."
        })]
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
        className: "status-".concat(progressBarType),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
          children: [percent, "%"]
        })
      }),
      classNameTooltip: "container-tooltip"
    })]
  });
};

exports.ProgressBar = ProgressBar;